module.exports = __webpack_public_path__ + "static/media/vivo.4507563a.svg";